import { ReactNode } from 'react'

import { T } from '@tribeplatform/react-components/i18n'
import { Accordion } from '@tribeplatform/react-ui-kit/Accordion'
import { SimpleDivider } from '@tribeplatform/react-ui-kit/Divider'

interface Props {
  children: ReactNode
}
export const ActionBarSettingSections = ({ children }: Props) => {
  return <div className="space-y-2">{children}</div>
}

interface HocProps {
  children: ReactNode
}
const SectionHOC = (title: JSX.Element, defaultOpen?: boolean) => {
  return ({ children }: HocProps) => {
    return (
      <>
        <SimpleDivider variant="subdued" />
        <Accordion
          defaultOpen={defaultOpen}
          iconAlign="trailing"
          className="-mx-2"
        >
          <Accordion.Button noHover className="hover:text-content-hovered">
            {title}
          </Accordion.Button>
          <Accordion.Panel>
            <div className="space-y-5">{children}</div>
          </Accordion.Panel>
        </Accordion>
      </>
    )
  }
}

ActionBarSettingSections.General = SectionHOC(
  <T defaultMessage="General" id="Generics.General" />,
  true,
)
ActionBarSettingSections.Label = SectionHOC(
  <T defaultMessage="Label" id="Generics.Label.Noun" />,
  true,
)
ActionBarSettingSections.Actions = SectionHOC(
  <T defaultMessage="Actions" id="Generics.Actions" />,
  true,
)
